import { Injectable, inject } from '@angular/core';
import { CustomerProfileData } from '@entities/domains/customer-profile.entity';
import { environment } from '@environment/environment';
import { CustomerProfileRepository } from '@repositories/customer-profile.repository';
import { RestApiService } from '@services/rest-api/rest-api.service';
import { BaseResponse } from '@utils/base-response.domain';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomerProfileAdapter extends CustomerProfileRepository {
    private readonly apiService = inject(RestApiService);

    constructor() { super(); }

    getCustomerProfile(): Observable<BaseResponse<CustomerProfileData>> {
        return this.apiService.getRequest(environment.serviceApi + 'customer/v1/profile', null);
    }
}
